import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import { ChartCard } from "./ChartCard";
import { AXIS_TEXT_COLOR, formatCount, GRID_COLOR, PRIMARY_COLOR, truncateLabel } from "./chartPalette";

const MAX_AXIS_LABEL_CHARS = 14;

// Truncates a long category label (e.g. a doctor or drug name) and puts the full text in a native
// SVG <title>, so hovering the axis label itself shows a browser tooltip with the untruncated value.
const TruncatedAxisTick = ({ x, y, payload }) => {
  const fullLabel = String(payload.value ?? "");
  const truncated = truncateLabel(fullLabel, MAX_AXIS_LABEL_CHARS);

  return (
    <text x={x} y={y} dy={4} textAnchor="end" fontSize={12} fill={AXIS_TEXT_COLOR}>
      {truncated}
      {truncated !== fullLabel && <title>{fullLabel}</title>}
    </text>
  );
};

export const BarChartCard = ({
  title,
  data = [],
  isLoading,
  dataKey = "count",
  valueFormatter = formatCount,
  color = PRIMARY_COLOR,
}) => {
  return (
    <ChartCard title={title} isLoading={isLoading} isEmpty={!isLoading && data.length === 0}>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={data} layout="vertical" margin={{ top: 4, right: 16, bottom: 4, left: 4 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={GRID_COLOR} horizontal={false} />
          <XAxis type="number" tick={{ fontSize: 12, fill: AXIS_TEXT_COLOR }} tickFormatter={valueFormatter} allowDecimals={false} />
          <YAxis
            type="category"
            dataKey="label"
            width={112}
            tick={<TruncatedAxisTick />}
            tickLine={false}
            interval={0}
          />
          <Tooltip formatter={(value) => valueFormatter(value)} />
          <Bar dataKey={dataKey} fill={color} radius={[0, 4, 4, 0]} maxBarSize={22} />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};
